module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis solicitudes de permisos")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (!_vm.isEditing) ? _c('div', {
    staticClass: "show-closed-text"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showClosed = !_vm.showClosed
      }
    }
  }, [(_vm.showClosed) ? [_vm._v("Mostrando todas las solicitudes")] : [_vm._v("Mostrando solo las solicitudes abiertas")]], 2)]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isEditing) ? _c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [(_vm.isMostrandoAdjuntar) ? _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('div', {
    ref: "adjuntarSolicitud",
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "adjuntar_solicitud_permiso",
      "folder": "permiso",
      "is-saved": _vm.isSavedAdjunto
    },
    on: {
      "close": _vm.closeAdjuntar,
      "save": _vm.guardarAdjunto
    }
  }, [_c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta la imagen que sustenta tu permiso")])])], 1)]) : _vm._e(), (_vm.mostrarConfirmacionEnviar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEnviar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEnviar = false
      },
      "do": _vm.enviarJefe
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea enviar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Enviando...")] : [_vm._v("Enviar")]], 2)]), _c('span', [_vm._v("Luego de enviar la notificación a su jefe, no podrá modificarlo")])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), _c('div', {
    staticClass: "is-desktop"
  }, [(_vm.isLoading) ? _c('loading') : _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return (_vm.showClosed || (!_vm.showClosed && o.estadoData.abierto)) ? _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.estadoData.abierto
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcionTipo))])]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2)], 2), _c('td', [_vm._v(_vm._s(o.estadoData.descripcion))]), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.abrirAdjuntar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-upload fs-12"
    })]), _c('span', [_vm._v("Adjuntar")])])], (o.estado === 1) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.enterEditMode(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarEnviar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Enviar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : (o.estado === 2) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : (o.estado === 3) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('span', [_vm._v("No hay acciones")])]) : _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('span', [_vm._v("No hay acciones")])])], 2)]) : _vm._e()
  }), 0)], 1)], 1), _c('div', {
    staticClass: "is-mobile"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._l((_vm.solicitudes), function(o, index) {
    return (_vm.showClosed || (!_vm.showClosed && o.estadoData.abierto)) ? _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('span', [_vm._v(_vm._s(o.estadoData.descripcion))])]), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, _vm._l((o.motivoLista), function(m) {
      return _c('div', [_c('span', [_vm._v(_vm._s(m))])])
    }), 0), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.abrirAdjuntar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-upload fs-12"
    })]), _c('span', [_vm._v("Adjuntar")])])], (o.estado === 1) ? [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.enterEditMode(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarEnviar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Enviar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])] : (o.estado === 2) ? [_c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])] : _vm._e()], 2)]) : _vm._e()
  })], 2)], 1) : _c('div', {
    key: "edit-solicitud"
  }, [_c('nueva-solicitud', {
    ref: "editarSolicitud",
    attrs: {
      "is-editing": true,
      "solicitud": _vm.solicitudSeleccionada
    },
    on: {
      "close": function($event) {
        _vm.isEditing = false
      },
      "closeRefresh": function($event) {
        _vm.isEditing = false;
        _vm.fetch();
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b0fa6e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Permisos_Lista_Solicitud.vue
// module id = 829
// module chunks = 0